import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getATLContextUrl, isFedRamp } from '@atlaskit/atlassian-context';
import { hostname, openInNewTab, origin, pathname, redirect } from '../../common/utils';
import { isTeamsAppEnabled } from '../../common/utils/is-teams-app-enabled';
export function generateTeamsAppPath(path, config) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new URLSearchParams();
  var anchor = arguments.length > 3 ? arguments[3] : undefined;
  if (config.cloudId) {
    query.set('cloudId', config.cloudId);
  }
  var pathWithLeadingSlash = path.startsWith('/') ? path : "/".concat(path);
  var pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : "/people".concat(pathWithLeadingSlash);
  var pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;

  // URLSearchParams.size doesn't work in jest
  var queryString = _toConsumableArray(new Set(query.keys())).length > 0 ? "?".concat(query.toString()) : '';

  // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
  // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
  // but for now, we need to generate a different URL for FedRamp.
  if (isFedRamp()) {
    // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return "https://teams".concat(isFedRampStaging() ? '.stg' : '', ".atlassian-us-gov.com").concat(pathWithoutPeoplePrefix).concat(anchor ? "#".concat(anchor) : '').concat(queryString);
  }
  var orgIdString = config.orgId ? "/o/".concat(config.orgId) : '';
  return "".concat(getATLContextUrl('home')).concat(orgIdString).concat(pathWithPeoplePrefix).concat(anchor ? "#".concat(anchor) : '').concat(queryString);
}
export function generatePath(path, config) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new URLSearchParams();
  var anchor = arguments.length > 3 ? arguments[3] : undefined;
  if (isTeamsAppEnabled(config) || config.hostProduct === 'home' || !config.hostProduct) {
    return generateTeamsAppPath(path, config, query, anchor);
  }
  var queryString = _toConsumableArray(new Set(query.keys())).length > 0 ? "?".concat(query.toString()) : '';
  return "".concat(origin(), "/").concat(config.hostProduct === 'confluence' ? 'wiki' : 'jira', "/people/").concat(path).concat(queryString);
}
export var onNavigateBase = function onNavigateBase(href, config) {
  return function (e) {
    if (e) {
      e.preventDefault();
    }
    if (isTeamsAppEnabled(config)) {
      if (config.shouldOpenInSameTab) {
        redirect(href);
        return;
      }
      openInNewTab(href);
      return;
    } else {
      if (config.shouldOpenInSameTab) {
        if (config.push) {
          config.push(href);
          return;
        }
        redirect(href);
        return;
      } else {
        openInNewTab(href);
        return;
      }
    }
  };
};
function stripAriFromId(id) {
  // Return everything after the last slash
  return id.split('/').pop() || '';
}
export function getPathAndQuery(action) {
  switch (action.type) {
    case 'LANDING':
    case 'DIRECTORY':
      return {
        path: ''
      };
    case 'USER':
      return {
        path: "".concat(stripAriFromId(action.payload.userId)),
        anchor: action.payload.section
      };
    case 'TEAM':
      return {
        path: "team/".concat(stripAriFromId(action.payload.teamId))
      };
    case 'AGENT':
      return {
        path: "agent/".concat(stripAriFromId(action.payload.agentId))
      };
    case 'KUDOS':
      return {
        path: "kudos/".concat(stripAriFromId(action.payload.kudosId))
      };
    case 'TEAMS_DIRECTORY':
      return {
        path: '',
        query: new URLSearchParams({
          screen: 'SEARCH_TEAMS'
        })
      };
    case 'PEOPLE_DIRECTORY':
      return {
        path: "search/people",
        query: new URLSearchParams(action.payload.query)
      };
    case 'USER_WORK':
      return {
        path: "".concat(stripAriFromId(action.payload.userId), "/work")
      };
    case 'CURRENT_USER_PROFILE':
      return {
        path: 'me'
      };
    default:
      return {
        path: ''
      };
  }
}

/**
 * @deprecated
 * This is a copy of the logic from @atlaskit/atlassian-context
 * We should delete it once we can register the teams domain in the context library
 */
export function isFedRampStaging() {
  var host = hostname();

  // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
  if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) {
    return true;
  }
  return false;
}
export function getHostProductFromPath() {
  var path = pathname();
  if (path.startsWith('/wiki')) {
    return 'confluence';
  }
  if (path.startsWith('/jira')) {
    return 'jira';
  }
  if (hostname().startsWith('home')) {
    return 'home';
  }
  return undefined;
}